import { VStack } from '@bpba/ui-components';
import { VALIDATE_SUBTITLE, VALIDATE_TITLE } from '../components/shared/Constantes';
import { StyledSpan } from '../components/shared/StyledSpan';
import { Title } from '../components/shared/Title';
import { FormValidate } from '../components/validate/FormValidate';

export const ValidatePage = () => {
  return (
    <VStack color={'white'} alignItems={'center'} mb={['200px']}>
      <Title title={VALIDATE_TITLE} textAlign="center" />
      <StyledSpan fontSize={['16px', '25px']} lineHeight={['28px', '38px']} fontWeight={500}>
        <div dangerouslySetInnerHTML={{ __html: VALIDATE_SUBTITLE }} />
      </StyledSpan>
      <FormValidate />
    </VStack>
  );
};
